export default __webpack_public_path__ + "static/red-3aaf29318df18aca4a0effde084bfed2.gif";